import type { Mutation } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'

const mutations: { [actionType: string]: Mutation<State> } = {
    [actionTypes.SET_PRODUCT_ADD_SUCCESS]: (state: State, status: boolean): void => {
        state.productAddSuccess = status
    },

}

export default mutations
